<template>
  <ul class="p-0">
    <li v-for="document in documents" :key="document.identifier">
      <i class="fa-solid fa-paperclip mb-2 mr-3 text-green" @click="downloadFile(document)"></i>
      <span>
        <u>{{ document.name }}</u>
        <i v-if="canViewAttachedDocument" @click="getFile(document, 'view')" class="fa fa-eye pl-2 cursor color-var-actionButtonColorBlue"></i>
        <i @click="getFile(document, 'download')" class="fa fa-download px-2 cursor color-var-actionButtonColorBlue"></i>
      </span>
    </li>
  </ul>
</template>
<script>
import { errorMessageAlert } from '@/helpers/alert'
import { downloadFileWithDefinedHeaders } from '@/helpers/download'

export default {
  name: 'documentList',
  props: {
    documents: []
  },
  data () {
    return {
      src: undefined
    }
  },
  computed: {
    canViewAttachedDocument () {
      return this.$engine.rights.rightIs('paymentattachment_consulter', true) 
    },
  },
  methods: {
    getFile (document, action) {
      let filename = document.name + '.' + document.format.toLowerCase()
      if (document.data) {
        let fileHeader = document.data.split(';').length > 1 ? document.data.split(';')[0].replace(/^data:/, '') : this.getFileHeader(document.format.toLowerCase())
        let fileData = document.data.split(',').length > 1 ? document.data.split(',')[0] : document.data
        if (action === 'download') {
          downloadFileWithDefinedHeaders(this, filename, fileHeader + fileData)
        } else if (action === 'view') {
          if (
            this.$f7.device.os === 'android' ||
            this.$f7.device.os === 'ios'
          ) {
            downloadFileWithDefinedHeaders(this, filename, fileHeader + fileData)
          } else {
            this.$bus.$emit('popup-document-viewer', {
              filename: filename,
              src: fileHeader + fileData
            })
          }
        }
      } else {
        this.$f7.showPreloader(this.$i18n.t('common.dwnldng_fl'))
        let that = this
        this.$engine.services.payments
          .getPaymentAttachment(document.id)
          .then((response) => {
            that.$f7.hidePreloader()
            document.data = response.data.data
            let fileHeader = document.data.split(';').length > 1 ? document.data.split(';')[0].replace(/^data:/, '') : this.getFileHeader(document.format.toLowerCase())
            let fileData = document.data.split(',').length > 1 ? document.data.split(',')[0] : document.data
            if (action === 'download') {
              downloadFileWithDefinedHeaders(this, filename, fileHeader + fileData)
            } else if (action === 'view') {
              if (
                that.$f7.device.os === 'android' ||
                that.$f7.device.os === 'ios'
              ) {
                downloadFileWithDefinedHeaders(that, filename, fileHeader + fileData)
              } else {
                that.$bus.$emit('popup-document-viewer', {
                  filename: filename,
                  src: fileHeader + fileData
                })
              }
            }
          })
          .catch((error) => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
          })
      }
    },
    getFileHeader (format) {
      switch (format) {
        case 'aac':
          return 'data:audio/aac;base64,'
        case 'abw':
          return 'data:application/x-abiword;base64,'
        case 'arc':
          return 'data:application/x-freearc;base64,'
        case 'avif':
          return 'data:image/avif;base64,'
        case 'avi':
          return 'data:video/x-msvideo;base64,'
        case 'azw':
          return 'data:application/vnd.amazon.ebook;base64,'
        case 'bin':
          return 'data:application/octet-stream;base64,'
        case 'bmp':
          return 'data:image/bmp;base64,'
        case 'bz':
          return 'data:application/x-bzip;base64,'
        case 'bz2':
          return 'data:application/x-bzip2;base64,'
        case 'cda':
          return 'data:application/x-cdf;base64,'
        case 'csh':
          return 'data:application/x-csh;base64,'
        case 'css':
          return 'data:text/css;base64,'
        case 'csv':
          return 'data:text/csv;base64,'
        case 'doc':
          return 'data:application/msword;base64,'
        case 'docx':
          return 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,'
        case 'eot':
          return 'data:application/vnd.ms-fontobject;base64,'
        case 'epub':
          return 'data:application/epub+zip;base64,'
        case 'gz':
          return 'data:application/gzip;base64,'
        case 'gif':
          return 'data:image/gif;base64,'
        case 'htm':
        case 'html':
          return 'data:text/html;base64,'
        case 'ico':
          return 'data:image/vnd.microsoft.icon;base64,'
        case 'ics':
          return 'data:text/calendar;base64,'
        case 'jar':
          return 'data:application/java-archive;base64,'
        case 'jpeg':
        case 'jpg':
          return 'data:image/jpeg;base64,'
        case 'js':
          return 'data:text/javascript;base64,'
        case 'json':
          return 'data:application/json;base64,'
        case 'jsonld':
          return 'data:application/ld+json;base64,'
        case 'mid':
        case 'midi':
          return 'data:audio/midi, audio/x-midi;base64,'
        case 'mjs':
          return 'data:text/javascript;base64,'
        case 'mp3':
          return 'data:audio/mpeg;base64,'
        case 'mp4':
          return 'data:video/mp4;base64,'
        case 'mpeg':
          return 'data:video/mpeg;base64,'
        case 'mpkg':
          return 'data:application/vnd.apple.installer+xml;base64,'
        case 'odp':
          return 'data:application/vnd.oasis.opendocument.presentation;base64,'
        case 'ods':
          return 'data:application/vnd.oasis.opendocument.spreadsheet;base64,'
        case 'odt':
          return 'data:application/vnd.oasis.opendocument.text;base64,'
        case 'oga':
          return 'data:audio/ogg;base64,'
        case 'ogv':
          return 'data:video/ogg;base64,'
        case 'ogx':
          return 'data:application/ogg;base64,'
        case 'opus':
          return 'data:audio/opus;base64,'
        case 'otf':
          return 'data:font/otf;base64,'
        case 'png':
          return 'data:image/png;base64,'
        case 'pdf':
          return 'data:application/pdf;base64,'
        case 'php':
          return 'data:application/x-httpd-php;base64,'
        case 'ppt':
          return 'data:application/vnd.ms-powerpoint;base64,'
        case 'pptx':
          return 'data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,'
        case 'rar':
          return 'data:application/vnd.rar;base64,'
        case 'rtf':
          return 'data:application/rtf;base64,'
        case 'sh':
          return 'data:application/x-sh;base64,'
        case 'svg':
          return 'data:image/svg+xml;base64,'
        case 'tar':
          return 'data:application/x-tar;base64,'
        case 'tif':
        case 'tiff':
          return 'data:image/tiff;base64,'
        case 'ts':
          return 'data:video/mp2t;base64,'
        case 'ttf':
          return 'data:font/ttf;base64,'
        case 'txt':
          return 'data:text/plain;base64,'
        case 'vsd':
          return 'data:application/vnd.visio;base64,'
        case 'wav':
          return 'data:audio/wav;base64,'
        case 'weba':
          return 'data:audio/webm;base64,'
        case 'webm':
          return 'data:video/webm;base64,'
        case 'webp':
          return 'data:image/webp;base64,'
        case 'woff':
          return 'data:font/woff;base64,'
        case 'woff2':
          return 'data:font/woff2;base64,'
        case 'xhtml':
          return 'data:application/xhtml+xml;base64,'
        case 'xls':
          return 'data:application/vnd.ms-excel;base64,'
        case 'xlsx':
          return 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
        case 'xml':
          return 'data:application/xml;base64,'
        case 'xul':
          return 'data:application/vnd.mozilla.xul+xml;base64,'
        case 'zip':
          return 'data:application/zip;base64,'
        case '3gp':
          return 'data:video/3gpp;base64,'
        case '3g2':
          return 'data:video/3gpp2;base64,'
        case '7z':
          return 'data:application/x-7z-compressed;base64,'
        default:
          return 'data:text/plain;base64,'
      }
    }
  }
}
</script>
